var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconAdddonor30 = function SvgAIconAdddonor30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 29C25.4183 29 29 25.4183 29 21C29 16.5817 25.4183 13 21 13C16.5817 13 13 16.5817 13 21C13 25.4183 16.5817 29 21 29Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17V25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.6817C2.37184 15.823 5.29223 14 8.5 14C9.81904 14 11.0895 14.3082 12.2237 14.87",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10C14.7767 6.84485 13.5678 2.56852 11.1539 2.56852C10.0005 1 7.79648 0.518382 5.49997 1.5C3.20347 2.48162 1.50011 6 3.50044 9.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14C11.2614 14 13.5 11.7614 13.5 9C13.5 7.07737 12.5 6 10.8236 5.5C9 7.5 5.36832 7.71437 3.7289 7.5C3.58018 7.97352 3.5 8.4774 3.5 9C3.5 11.7614 5.73858 14 8.5 14Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconAdddonor30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjEgMjlDMjUuNDE4MyAyOSAyOSAyNS40MTgzIDI5IDIxQzI5IDE2LjU4MTcgMjUuNDE4MyAxMyAyMSAxM0MxNi41ODE3IDEzIDEzIDE2LjU4MTcgMTMgMjFDMTMgMjUuNDE4MyAxNi41ODE3IDI5IDIxIDI5WiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTIxIDE3VjI1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTcgMjFIMjUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xIDE4LjY4MTdDMi4zNzE4NCAxNS44MjMgNS4yOTIyMyAxNCA4LjUgMTRDOS44MTkwNCAxNCAxMS4wODk1IDE0LjMwODIgMTIuMjIzNyAxNC44NyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTEzLjUgMTBDMTQuNzc2NyA2Ljg0NDg1IDEzLjU2NzggMi41Njg1MiAxMS4xNTM5IDIuNTY4NTJDMTAuMDAwNSAxIDcuNzk2NDggMC41MTgzODIgNS40OTk5NyAxLjVDMy4yMDM0NyAyLjQ4MTYyIDEuNTAwMTEgNiAzLjUwMDQ0IDkuNSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTguNSAxNEMxMS4yNjE0IDE0IDEzLjUgMTEuNzYxNCAxMy41IDlDMTMuNSA3LjA3NzM3IDEyLjUgNiAxMC44MjM2IDUuNUM5IDcuNSA1LjM2ODMyIDcuNzE0MzcgMy43Mjg5IDcuNUMzLjU4MDE4IDcuOTczNTIgMy41IDguNDc3NCAzLjUgOUMzLjUgMTEuNzYxNCA1LjczODU4IDE0IDguNSAxNFoiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";